import { useHistory } from 'react-router-dom';

const isClientSideRoute = (route: string) =>
	!route.startsWith('http') && !route.endsWith('pdf') && !route.endsWith('exe') && !route.endsWith('zip');

export const useClientOrServerSideRouting = () => {
	const history = useHistory();

	return (to: string) => {
		if (isClientSideRoute(to)) {
			history.push(to);
		} else {
			window.location.href = to;
		}
	};
};
